module.exports = __webpack_public_path__ + "b34ae24bea9dec8da61c406c6c8fa45e.MP3";